module.exports = __webpack_public_path__ + "static/img/bottom3.e17f09fd.png";